export default {
  lobby:{
    pano:"./sala2_game.png",
    marks: [
      {
        id: "pinmark1",
        longitude: 2.51,
        latitude: -0.01,
        image: "https://photo-sphere-viewer.js.org/assets/pin-blue.png",
        width: 32,
        height: 32,
        anchor: "bottom center",
        tooltip: "Desactivaron el sistema de alarma, parece que hay huellas digitales",
      },
      {
        id: "pinmark2",
        longitude: 1.224,
        latitude: -0.421,
        image: "https://photo-sphere-viewer.js.org/assets/pin-blue.png",
        width: 32,
        height: 32,
        anchor: "bottom center",
        tooltip: "Esto parece ser una pluma de ave",
      },
      {
        id: "pinmark3",
        longitude: 0.451,
        latitude: -0.567,
        image: "https://photo-sphere-viewer.js.org/assets/pin-blue.png",
        width: 32,
        height: 32,
        anchor: "bottom center",
        tooltip: "El sospechoso utilizaba botas industriales",
      },
      {
        id: "pinmark4",
        longitude: 4.79,
        latitude: -0.007,
        image: "https://photo-sphere-viewer.js.org/assets/pin-blue.png",
        width: 32,
        height: 32,
        anchor: "bottom center",
        tooltip: "Manchas de pintura ¿Por qué la arrojarían al muro?",
      },
      {
        id: "pinmark5",
        longitude: 3.58,
        latitude: -0.25,
        image: "https://photo-sphere-viewer.js.org/assets/pin-blue.png",
        width: 32,
        height: 32,
        anchor: "bottom center",
        tooltip: "Todo parece indicar que entraron usando la fuerza",
      },
      {
        id: "pinmark6",
        longitude: 5.765,
        latitude: 0.051,
        image: "https://photo-sphere-viewer.js.org/assets/pin-blue.png",
        width: 32,
        height: 32,
        anchor: "bottom center",
        tooltip: "Parece que en estas notas hay un mensaje cifrado",
      },
      {
        id: "mark1",
        polylineRad: [
          [1.925, 0.14],
          [2.116, 0.13],
          [2.12, -0.13],
          [1.925, -0.14],
          [1.925, 0.14]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(255, 255, 0, 0.95)",
          strokeWidth: "5px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "¡Encuentra el cuadro extraviado!",
          position: "right bottom"
        }
      },
      {
        id: "mark2",
        polylineRad: [
          [0.862, 0.115],
          [1.272, 0.136],
          [1.256, -0.136],
          [0.826, -0.114],
          [0.862, 0.115]
        ],
        svgStyle: {
          fill: "rgba(255, 255, 0, 0.0)",
          stroke: "rgba(255, 255, 0, 0.95)",
          strokeWidth: "5px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "¡Encuentra el objeto extraviado!",
          position: "right bottom"
        }
      },
      {
        id: "mark3",
        polylineRad: [
          [5.032, 0.184],
          [5.289, 0.163],
          [5.289, -0.204],
          [5.031, -0.23],
          [5.032, 0.184]
        ],
        svgStyle: {
          fill: "rgba(255, 255, 0, 0.0)",
          stroke: "rgba(255, 255, 0, 0.95)",
          strokeWidth: "5px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "¡Encuentra el cuadro extraviado!",
          position: "right bottom"
        }
      },
      {
        id: "mark1Content",
        visible: false,
        polylineRad: [
          [1.925, 0.14],
          [2.116, 0.13],
          [2.12, -0.13],
          [1.925, -0.14],
          [1.925, 0.14]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 25, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "El nacimiento de una Nación Independiente",
          position: "right bottom"
        },
        info: {
          template: "mark1Content",
          images: [
            "galerias/gameRoom/acta_independencia.jpg"
          ]
        }
      },
      {
        id: "mark2Content",
        visible: false,
        polylineRad: [
          [0.862, 0.115],
          [1.272, 0.136],
          [1.256, -0.136],
          [0.826, -0.114],
          [0.862, 0.115]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 25, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Penacho de Moctezuma",
          position: "right bottom"
        },
        info: {
          template: "mark2Content",
          images: [
            "galerias/gameRoom/penacho.png"
          ]
        }
      },
      {
        id: "mark3Content",
        visible: false,
        polylineRad: [
          [5.032, 0.184],
          [5.289, 0.163],
          [5.289, -0.204],
          [5.031, -0.23],
          [5.032, 0.184]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 25, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "La cultura y las artes Virreinales",
          position: "right bottom"
        },
        info: {
          template: "mark3Content",
          images: [
            "galerias/gameRoom/sor_juana_ines_de_la_cruz.jpg"
          ]
        }
      },
      {
        id: "mark4Content",
        polylineRad: [
          [4.038, 0.115],
          [4.355, 0.13],
          [4.354, -0.24],
          [4.03, -0.202],
          [4.038, 0.115]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 25, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "El comercio en la Nueva España",
          position: "right bottom"
        },
        info: {
          template: "mark4Content",
          images: [
            "galerias/gameRoom/barco.png"
          ]
        }
      },
      {
        id: "mark5Content",
        polylineRad: [
          [5.95, 0.314],
          [0.335, 0.313],
          [0.33, -0.355],
          [5.95, -0.352],
          [5.95, 0.314]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 25, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Piedra del sol. Tesoros del mundo prehispánico",
          position: "right bottom"
        },
        info: {
          template: "mark5Content",
          images: [
            "galerias/gameRoom/piedra_del_sol.png"
          ]
        }
      },
      {
        id: "exit:lobby:0",
        polylineRad: [
          [2.573, 0.127],
          [3.698, 0.127],
          [3.699, -0.215],
          [2.571, -0.215],
          [2.573, 0.127]
        ],
        svgStyle: {
          fill: "rgba(250, 0, 0, 0.2)",
          stroke: "rgba(250, 0, 0, 0.95)",
          strokeWidth: "5px",
          // strokeDasharray: 5
        },
        tooltip: {
          content: "Salida",
          position: "right bottom"
        }
      }
    ]
  }
};
